import { LifeBuoy, CheckCircle2 } from "lucide-react";
import { SupportButtons } from "@/components/Brand";
import { SUPPORT_PHONE, fmtDate } from "@/lib/api";
import { usePanel } from "./PanelContext";

export default function Support() {
  const { me, biz } = usePanel();
  return (
    <div className="space-y-6 rise max-w-4xl" data-testid="support-page">
      <div><h1 className="text-3xl font-extrabold">Destek Merkezi</h1><p className="text-sm text-slate-500">Kurulum, aktivasyon ve her türlü sorunuz için bize ulaşın.</p></div>
      <div className="rounded-3xl bg-[#0F1F45] text-white p-8 grain relative">
        <LifeBuoy className="h-10 w-10 text-[#FF6B0A]" />
        <h2 className="mt-4 text-2xl font-bold">WhatsApp veya telefonla anında destek</h2>
        <p className="mt-2 text-white/70">Destek hattı: <b className="text-white" data-testid="support-phone-text">{SUPPORT_PHONE}</b></p>
        <div className="mt-6"><SupportButtons prefix="panel-support" /></div>
      </div>
      <div className="rounded-3xl bg-white border p-8 grid md:grid-cols-2 gap-6">
        <div>
          <p className="text-xs uppercase tracking-widest font-bold text-[#FF6B0A]">Teklif</p>
          <p className="mt-2 font-display text-5xl font-black" data-testid="support-price">6.000 TL</p>
          <p className="text-slate-500">yıllık • tüm modüller dahil</p>
          <p className="mt-4 text-sm">Lisans durumu: <b className={me.license_active ? "text-emerald-600" : "text-amber-600"} data-testid="support-license-status">{me.license_active ? `Aktif (${fmtDate(biz.license_until)}'e kadar)` : "Aktif değil"}</b></p>
        </div>
        <ul className="space-y-2 text-sm">
          {["Panel lisansı", "Yemeksepeti aktivasyonu", "Trendyol Go Yemek aktivasyonu", "Migros Yemek aktivasyonu", "QR kod ve masa sistemi", "Kurye ve Caller ID uygulamaları"].map((t) => (
            <li key={t} className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-[#FF6B0A]" />{t} <span className="ml-auto text-xs text-slate-400">yıllık</span></li>
          ))}
        </ul>
      </div>
    </div>
  );
}
